import { CrudAbstractModel } from "../../crud-abstract/crud-abstract.model";
import { Location } from "../../location/location.model";
import { Rate } from "../rate-type";
import { LocationMapper } from "../../location/location.mapper";
import { RateMapper } from "../rate.mapper";
import { RateFlatRouteMapper } from "./rate-flat-route.mapper";
import { countryCodes } from "../../shared/countries/country-codes.const";
import { RateFlatRoute } from "./rate-flat-route.type";

export class RateLclFlatRoute extends CrudAbstractModel {
  constructor(
    public id: number,
    public discriminator: string,
    public rate: Rate,
    public originLocation: Location,
    public destinationLocation: Location,
    public currency: string,
    public comment: string,
    public weightPrice: number,
    public measurementPrice: number,
    public blPrice: number,
    public minPrice: number,
  ) {
    super(id);
  }

  public getId(): number {
    return this.id;
  }

  public getDiscriminator(): string {
    return this.discriminator;
  }

  public setId(param: number) {
    this.id = param;
  }

  public getRate(): Rate {
    return this.rate;
  }

  public get destinationCountryName(): string {
    return this.destinationLocation
      ? countryCodes[this.destinationLocation.getCountry()]
      : null;
  }

  public get originCountryName(): string {
    return this.originLocation
      ? countryCodes[this.originLocation.getCountry()]
      : null;
  }

  public getRequestParams() {
    return {
      originLocation: this.originLocation.getId(),
      destinationLocation: this.destinationLocation.getId(),
      comment: this.comment,
      currency: this.currency,
      weightPrice: this.weightPrice,
      measurementPrice: this.measurementPrice,
      blPrice: this.blPrice,
      minPrice: this.minPrice,
    };
  }

  public isValid(): boolean {
    return (
      !!this.originLocation && !!this.destinationLocation && !!this.currency
    );
  }

  public getClone(): RateFlatRoute {
    return RateFlatRouteMapper.map({
      id: this.getId(),
      discriminator: this.discriminator,
      rate: RateMapper.map(this.rate),
      originLocation: LocationMapper.map(this.originLocation),
      destinationLocation: LocationMapper.map(this.destinationLocation),
      currency: this.currency,
      comment: this.comment,
      weightPrice: this.weightPrice,
      measurementPrice: this.measurementPrice,
      blPrice: this.blPrice,
      minPrice: this.minPrice,
    });
  }
}
